export default "__VITE_ASSET__fe6e78fe__"